module.exports = __webpack_public_path__ + "img/Barbarian_Axe_OneHanded.70ed6a3b.png";